import Image from "next/image";

import charlotte from "@/assets/images/charlotte.png";
import Button from "@/components/atoms/Button";
import { DiamondForCharlotte } from "@/components/atoms/DiamondForCharlotte";
import Icon from "@/components/atoms/Icon";
import { useTranslation } from "@/i18n/client";
import { AllowedLanguages } from "@/types/generic";

interface JobsChatProps {
  locale: AllowedLanguages;
  params: string[];
}

export const JobsChat = ({ locale, params }: JobsChatProps) => {
  const { t } = useTranslation(locale);
  const link = `https://charlotte.vivaldisinterim.be/?first_message=${params.join(",")}`;

  return (
    <>
      <div className="flex flex-row items-start gap-6">
        <div className="flex flex-col items-center gap-2 md:gap-2.5">
          <div className="relative">
            <Image
              src={charlotte}
              alt="Charlotte"
              className="ratio-square w-[80px] flex-shrink-0 md:w-[159px]"
              width="159"
              height="159"
            />
            <DiamondForCharlotte className="absolute right-[-41px] top-[29px] md:top-[59px]" />
          </div>
          <span className="font-regular text-black-400 md:font-medium">
            Charlotte
          </span>
        </div>
        <div className="flex flex-grow flex-col gap-y-6 rounded-2xl bg-green p-6 md:p-12">
          <h5 className="text-white">{t("pages.jobs.jobs_chat.title")}</h5>
          <div
            className="text-white"
            dangerouslySetInnerHTML={{
              __html: t("pages.jobs.jobs_chat.description"),
            }}
          />
          <div>
            <Button
              href={link}
              as="link"
              className="btn-yellow-light btn-sm md:btn-lg basic-1 whitespace-nowrap"
              arrow={false}
            >
              <Icon name="chat" className="mr-3 h-5 w-5" />
              {t("pages.jobs.jobs_chat.btn")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobsChat;
